import {CanActivateFn, RedirectCommand, Router, UrlTree} from '@angular/router';
import {inject} from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authPath = router.parseUrl('/auth');
  const accessToken = localStorage.getItem('accessToken');
  if (accessToken) {
    return true
  } else {
    return new RedirectCommand(authPath)
  }
};
